import { createSelector } from 'reselect'
import { State } from 'index'

const categorySelector = (state: State) => state.category

export const getCategories = createSelector([categorySelector], (state) => state.categories)
